<template>
  <!-- 底栏 -->
  <div class="b">
    <div class="bg"></div>
    <div class="w">
      <div class="m">
        <div class="logo">
          <img style=" height: 54px;" :src="logo" />
        </div>
        <div class="lj">
          <span>友情链接：</span>
          <div style="display: flex;align-items: center;" v-for="(item,index) in members" :key="item.id">
            <span style="cursor: pointer;" @click="toISOString(item)">{{item.name}}</span>
            <div v-if="index < members.length - 1" class="l"></div>

          </div>


        </div>
        <div class="lb">
          <div class="lb_l">
            地址：{{ copyright.areaProvinceName }}{{ copyright.areaCityName }}{{ copyright.areaNameName }}{{
              copyright.addressName }}　邮编：{{ copyright.postcode }}
          </div>
          <div v-html="copyright.copyright" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Bus from '@/api/bus'
import Vue from 'vue'
import { getImagePage } from '@/api/home'
import { getDomain, getDomainLogo } from '@/api/cookies'
import { getInfo } from '@/api/cookies'
import { TeacherClient } from '@/api/teacherClient.js'
let teacherClient = new TeacherClient()
export default {
  data() {
    return {
      path: '/',

      logo: '',
      copyright: {},
      members: []
    }
  },
 
  async created() {
    this.path = window.location.pathname
    this.userInfo = getInfo()
    this.logo = getDomainLogo()
    this.copyright = getDomain()
    teacherClient.getEntrantsRelation({

    }).then((res) => {
      this.members = res.data.linkVoList
    })
  },
  mounted() {

  },
  methods: {
     toISOString(item) {
      if (item.nameUrl) {
        window.open(item.nameUrl, '_blank')
      }
    },
    gopage(path, type) {
      if (this.path == path) {
        return
      }
      if (type) {
        // window.open(path, "_blank");
        this.$router.push(path)
      } else {
        /* this.$router.push(path); */
        // window.open(path, "_blank");
        this.$router.push(path)
      }
    },

  }
}
</script>
<style lang="less" scoped>
.b {
  width: 100%;
  // height: 282px;
  margin-top: 20px;

  .bg {
    width: 100%;
    height: 100px;
    background: url('https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x4.png');
    background-size: 100% 100%;
  }

  .w {
    width: 100%;
    // height: 217px;
    background: #1D7DF5;
    padding-bottom: 20px;

    .m {
      width: 1400px;
      margin: 0 auto;

      .logo {
        height: 54px;
      }

      .lj {
        width: 1400px;
        height: 61px;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 10px 10px 10px 10px;
        border: 1px solid rgba(112, 112, 112, 0.1);
        margin-top: 22px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #FFFFFF;
        display: flex;
        align-items: center;
        padding: 0 20px;

        .l {
          width: 0px;
          height: 11px;
          border-right: 1px solid #FFFFFF;
          margin: 0 15px;
        }
      }

      .lb {
        margin-top: 21px;

        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 26px;
        display: flex;
        justify-content: space-between;
      }
    }

  }



}
</style>
